<template>
  <div class="px-4">
    <template v-if="!me">
      <h1 class="mt-5 mb-5">사용자 생성/로그인을 해야 나머지 항목이 보입니다.</h1>
      <div v-for="(manage, $index) in manages" :key="manage.name" class="mb-4">
        <template v-if="$index < 2">
          <v-card :to="`${manage.to}`" :disabled="manage.disabled?.()" class="rounded-4">
            <v-card-title>
              <v-layout justify-space-between>
                <h3 class="font-size--18" :class="{ 'color--nice-black': !manage.complete?.() }">
                  {{ manage.name }}
                  <span v-if="manage.required">(필수)</span>
                </h3>
                <v-icon v-if="manage.complete?.()" size="20" color="success" class="mr-1"
                  >mdi-check</v-icon
                >
                <v-icon v-else color="grey" size="24">mdi-chevron-right</v-icon>
              </v-layout>
            </v-card-title>
          </v-card>
        </template>
      </div>
    </template>
    <template v-else>
      <div>
        <div class="mt-5">
          <span>로그인: {{ me.email }}</span>
        </div>
        <div class="mt-10">
          <div class="mb-2">
            <h1>사전 등록용 정보 & 서류</h1>
          </div>
          <div v-for="manage in manages1" :key="manage.name" class="mb-4">
            <v-card :to="`${manage.to}`" :disabled="manage.disabled?.()" class="rounded-4">
              <v-card-title>
                <v-layout justify-space-between>
                  <h3 class="font-size--18" :class="{ 'color--nice-black': !manage.complete?.() }">
                    {{ manage.name }}
                    <span v-if="manage.required">(필수)</span>
                  </h3>
                  <v-icon v-if="manage.complete?.()" size="20" color="success" class="mr-1"
                    >mdi-check</v-icon
                  >
                  <v-icon v-else color="grey" size="24">mdi-chevron-right</v-icon>
                </v-layout>
              </v-card-title>
            </v-card>
          </div>
        </div>
      </div>

      <div class="mt-10">
        <div class="mb-2">
          <h1>가맹점과 함께 진행</h1>
        </div>
        <div v-for="manage in manages2" :key="manage.name" class="mb-4">
          <v-card :to="`${manage.to}`" :disabled="manage.disabled?.()" class="rounded-4">
            <v-card-title>
              <v-layout justify-space-between>
                <h3 class="font-size--18" :class="{ 'color--nice-black': !manage.complete?.() }">
                  {{ manage.name }}
                  <span v-if="manage.required">(필수)</span>
                </h3>
                <v-icon v-if="manage.complete?.()" size="20" color="success" class="mr-1"
                  >mdi-check</v-icon
                >
                <v-icon v-else color="grey" size="24">mdi-chevron-right</v-icon>
              </v-layout>
            </v-card-title>
          </v-card>
        </div>
      </div>
    </template>
    <!--     
    <ul class="ml-5">
      <li v-for="(manage, $index) in manages" :key="manage.name">
        <h1>
          <template v-if="manage.disabled?.()">
            <span v-if="$index === 0">{{ me.email }}</span>
            <span v-if="$index > 1">{{ manage.name }}</span>
          </template>
          <router-link v-else :to="`${manage.to}`" :disabled="manage.disabled?.()">
            {{ manage.name }}
            <span v-if="manage.complete?.()">(완료)</span>
          </router-link>
        </h1>
      </li>
    </ul> -->
    <basic-button @click="complete()"> 완료 </basic-button>
  </div>
</template>

<script>
import BasicButton from '@/components/common/button/BasicButton.vue'
import { mapActions, mapState } from 'vuex'
import { sleep } from '@/util'
export default {
  components: {
    BasicButton,
  },
  data() {
    return {
      isAccounts: false,
      isFactoringConfirm: false,
      isVerifiedIdCard: false,
      isDocuments: false,
      isCertificateOfIncomeAmount: false,
      manages: [
        {
          name: '사용자 생성',
          to: '/signup',
          complete: () => {
            return this.me
          },
          disabled: () => {
            return this.me
          },
        },
        {
          name: '사용자 로그인',
          to: '/signin',
          complete: () => {
            return this.me
          },
          disabled: () => {
            return this.me
          },
        },
        // {
        //   name: '사용자 정보',
        //   to: '/auth/identity',
        //   complete: () => {
        //     return this.me?.mobileCarrier
        //   },
        //   disabled: () => {
        //     return !this.me
        //   },
        //   required: true,
        // },
        // {
        //   name: '상점 정보',
        //   to: '/signup/store',
        //   complete: () => {
        //     return this.me?.store.typeOfBusiness
        //   },
        //   disabled: () => {
        //     return !this.me
        //   },
        //   required: true,
        // },
        // {
        //   name: '본인인증',
        //   to: '/kyc/verify-id/confirm',
        //   complete: () => {
        //     return this.me?.kyc.mobileVerificationIsDone
        //   },
        //   disabled: () => {
        //     return !this.me
        //   },
        //   required: true,
        // },
        // {
        //   name: '매출 계정 연동',
        //   to: '/auth/accounts/sales',
        //   complete: () => {
        //     return this.isAccounts
        //   },
        //   disabled: () => {
        //     return !this.me
        //   },
        // },
        // {
        //   name: '신용평가',
        //   to: '/factoring/confirm',
        //   complete: () => {
        //     return this.isFactoringConfirm
        //   },
        //   disabled: () => {
        //     return !this.me
        //   },
        // },
        // {
        //   name: '신분증제출',
        //   to: '/kyc/verify-id-card',
        //   complete: () => {
        //     return this.isVerifiedIdCard
        //   },
        //   disabled: () => {
        //     return !this.me
        //   },
        // },
        // {
        //   name: '필요서류제출',
        //   to: '/signup/documents',
        //   complete: () => {
        //     return this.isDocuments
        //   },
        //   disabled: () => {
        //     return !this.me
        //   },
        // },
        // {
        //   name: '출금계좌등록',
        //   to: '/signup/bank/withdrawal',
        //   complete: () => {
        //     return this.me?.withdrawalAccount?.accountNumber
        //   },
        //   disabled: () => {
        //     return !this.me
        //   },
        // },
        // {
        //   name: '매출집금계좌',
        //   to: '/signup/bank/collections',
        //   complete: () => {
        //     return this.me?.collectionAccount?.accountNumber
        //   },
        //   disabled: () => {
        //     return !this.me
        //   },
        // },
        // {
        //   name: '소득증명',
        //   to: '/signup/certification/income',
        //   complete: () => {
        //     return this.isCertificateOfIncomeAmount
        //   },
        //   disabled: () => {
        //     return !this.me
        //   },
        // },
      ],
      manages1: [
        {
          name: '사용자 정보',
          to: '/auth/identity',
          complete: () => {
            return this.me?.mobileCarrier
          },
          disabled: () => {
            return !this.me
          },
          required: true,
        },
        {
          name: '상점 정보',
          to: '/signup/store',
          complete: () => {
            return this.me?.store.typeOfBusiness
          },
          disabled: () => {
            return !this.me
          },
          required: true,
        },
        {
          name: '매출 계정 연동',
          to: '/auth/accounts/sales',
          complete: () => {
            return this.isAccounts
          },
          disabled: () => {
            return !this.me
          },
        },
        {
          name: '한도 산출',
          to: '/loan/pull-revenue-manage',
          complete: () => {
            return true
          },
          disabled: () => {
            return !this.me
          },
          required: false,
        },
        {
          name: '신분증제출',
          to: '/kyc/verify-id-card',
          complete: () => {
            return this.isVerifiedIdCard
          },
          disabled: () => {
            return !this.me
          },
        },
        {
          name: '필요서류제출',
          to: '/signup/documents',
          complete: () => {
            return this.isDocuments
          },
          disabled: () => {
            return !this.me
          },
        },
      ],
      manages2: [
        {
          name: '본인인증',
          to: '/kyc/verify-id/confirm',
          complete: () => {
            return this.me?.kyc.mobileVerificationIsDone
          },
          disabled: () => {
            return !this.me
          },
          required: true,
        },
        {
          name: '신용평가',
          to: '/factoring/confirm',
          complete: () => {
            return this.isFactoringConfirm
          },
          disabled: () => {
            return !this.me
          },
        },
        {
          name: '입금용 주계좌 등록',
          to: '/signup/bank/withdrawal',
          complete: () => {
            return this.me?.withdrawalAccount?.accountNumber
          },
          disabled: () => {
            return !this.me
          },
        },
        {
          name: '매출 집금계좌 등록',
          to: '/signup/bank/collections',
          complete: () => {
            return this.me?.collectionAccount?.accountNumber
          },
          disabled: () => {
            return !this.me
          },
        },
        {
          name: '소득증명',
          to: '/signup/certification/income',
          complete: () => {
            return this.isCertificateOfIncomeAmount
          },
          disabled: () => {
            return !this.me
          },
        },
      ],
    }
  },
  computed: {
    ...mapState('auth', {
      me: 'me',
      signinToken: 'token',
    }),
    ...mapState('document', ['fileObj']),
  },
  async created() {
    this.$cookies.set('signupManage', 'manage', 0)
    await this.init()
  },
  methods: {
    ...mapActions('auth', {
      storeSignout: 'signout',
    }),
    ...mapActions('evaluation', ['getCreditEvaluationsCurrent']),
    ...mapActions('account', ['getAccounts']),
    ...mapActions('document', ['getDocuments']),
    async init() {
      if (!this.signinToken) {
        return
      }
      if (!this.me) {
        await sleep(500)
        return this.init()
      }

      const accounts = await this.getAccounts()
      this.isAccounts = accounts.length > 0

      const evaluationsCurrent = await this.getCreditEvaluationsCurrent()
      this.isFactoringConfirm = Object.keys(evaluationsCurrent).length > 0

      await this.getDocuments()
      const { idCardVerificationIsDone } = this.me.kyc
      const { identification, businessLicense, certificateOfIncomeAmount } = this.fileObj
      this.isVerifiedIdCard = idCardVerificationIsDone === true && identification
      this.isDocuments = !!businessLicense
      this.isCertificateOfIncomeAmount = !!certificateOfIncomeAmount
    },
    async complete() {
      try {
        const { isConfirmed } = await this.$swal.basic.confirm({
          html: `완료 하시겠습니까?<br/>
          완료 후에는 로그인 화면으로 이동 됩니다.`,
        })
        if (!isConfirmed) {
          return
        }
        await this.$router.replace('/signin')
      } finally {
        this.$cookies.remove('signupManage')
        this.storeSignout()
      }
    },
  },
}
</script>
